import { GET_COURSE_COUNT, GET_CLASS_SCHEDULE, GET_TEACH_LIST, GET_COURSE_LIST, IS_USERCENTER } from '../type/UserCenter.type';
const initialState = {
	teachList: {
		page: {},
		courses: []
	},
	courseList: {
		page: {},
		courses: []
	},
	isUserCenter: false,
	courseCounts: [],
	classSchedule: []
};
const UserCenterDatas = (state = { ...initialState }, action) => {
	let copyState = { ...state };
	switch (action.type) {
		case GET_COURSE_COUNT:
			copyState.courseCounts = action.res;
			return copyState;
		case GET_CLASS_SCHEDULE:
			copyState.classSchedule = action.res;
			return copyState;
		case GET_TEACH_LIST:
			copyState.teachList = action.res;
			return copyState;
		case GET_COURSE_LIST:
			copyState.courseList = action.res;
			return copyState;
		case IS_USERCENTER:
			copyState.isUserCenter = action.res;
			return copyState;
		default:
			return copyState;
	}
};
export default UserCenterDatas;



// WEBPACK FOOTER //
// ./src/redux/reducer/UserCenter.reducer.js